import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { BootRetryScreen } from '../components/BootRetryScreen/BootRetryScreen';
import { MobileViewportWidthProvider } from '../providers/MobileViewportWidthProvider';
import { MOUNT_NODE_ID } from './mountNode';
export const makeRenderRetryScreen = (loadNative)=>(error)=>{
        // eslint-disable-next-line no-console
        console.error('[native-bootstrap] failed to load /config:', error);
        void loadNative().then((nativeModule)=>nativeModule.bootLifecycle.markFailed('config-load-failed', error)).catch(()=>{});
        const root = createRoot(document.getElementById(MOUNT_NODE_ID));
        root.render(/*#__PURE__*/ _jsx(MobileViewportWidthProvider, {
            children: /*#__PURE__*/ _jsx(BootRetryScreen, {
                biName: "native_bootstrap_retry",
                onRetry: ()=>window.location.reload()
            })
        }));
    };
